import React from 'react';
import { Icon } from '../../Icon';
import { BUY_LABEL } from '../../commons';
import { CardInfo, CardText, CardTitle, OrganizationRole, OrganizationName, Actions } from './partials';
export var OrganizationCard = function OrganizationCard(_ref) {
  var entity = _ref.entity,
    role = _ref.role,
    onAction = _ref.onAction;
  var url = entity.web;
  var icon = entity.icon,
    displayName = entity.displayName;
  var iconURL = icon ? "https://www.finect.com/image/".concat(icon) : null;
  return React.createElement(CardInfo, null, React.createElement(Icon, {
    type: entity.subtype,
    size: 4,
    alt: displayName,
    image: iconURL,
    margin: "0 18px 0 0",
    aditionalIcon: null,
    verified: true,
    withBorder: true,
    url: url
  }), React.createElement(CardText, {
    centered: false
  }, React.createElement(CardTitle, null, React.createElement(OrganizationRole, null, role || null), React.createElement(OrganizationName, {
    href: url
  }, displayName), React.createElement(Actions, null, React.createElement("a", {
    href: url
  }, "M\xE1s informaci\xF3n"), React.createElement("span", {
    onClick: onAction
  }, BUY_LABEL)))));
};